import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_29282_3007)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.9762 6.06533C13.2342 6.328 13.2302 6.75 12.9668 7.008L10.0162 9.90467C9.49416 10.4167 8.82216 10.672 8.1495 10.672C7.48416 10.672 6.81883 10.4213 6.29883 9.91933L5.03283 8.67467C4.77016 8.41667 4.76683 7.99467 5.02483 7.732C5.28216 7.46867 5.7055 7.46533 5.9675 7.724L7.2295 8.96467C7.74683 9.46467 8.5635 9.462 9.0835 8.95267L12.0335 6.05667C12.2955 5.798 12.7162 5.80267 12.9762 6.06533ZM16.8335 8C16.8335 12.4113 13.2448 16 8.8335 16C4.42216 16 0.833496 12.4113 0.833496 8C0.833496 3.58867 4.42216 0 8.8335 0C13.2448 0 16.8335 3.58867 16.8335 8ZM15.5002 8C15.5002 4.324 12.5095 1.33333 8.8335 1.33333C5.1575 1.33333 2.16683 4.324 2.16683 8C2.16683 11.676 5.1575 14.6667 8.8335 14.6667C12.5095 14.6667 15.5002 11.676 15.5002 8Z",
			fill: "#1CB954"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29282_3007",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0.833496)"
		})
	}) })]
});
export default SvgSuccess;
